import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const ANNEXII_ENDPOINTS = {
  get_annexii_by_campaign_member: (id_campaign, id_member) => `${BASE_URL}api/annexeii/${id_campaign}/${id_member}`,
  create_annexii: `${BASE_URL}api/annexeii/`,
  download_annexii: (campaign_id, member_id) =>
    `${BASE_URL}api/annexeii/${campaign_id}/${member_id}/annexeii/download`,

}

class Annexii {
  async getAnnexIByCampaignMember(id_campaign, id_member) {
    const { data } = await request({
      url: ANNEXII_ENDPOINTS.get_annexii_by_campaign_member(id_campaign, id_member)
    });

    return data;
  };

  async createAnnexii(payload) {
    return await request({
      url: ANNEXII_ENDPOINTS.create_annexii,
      method: "POST",
      body: payload
    });
  };
}

export const AnnexIIService = new Annexii();
